import styles from './QA.module.scss'
import { useRef, useEffect } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger)

interface FAQList {
  questionText: string
  answerText: string
}

const FAQLists: FAQList[] = [
  {
    questionText: 'コストをかけずにやる方法はありますか？',
    answerText:
      '既存のUIライブラリをカスタマイズして活用するなど、コンパクトに始める方法があります。運用体制によっては、システムに厳格な制約を設ける必要がない場合など、状況に応じてプロジェクトの範囲と深さが変わりますので、是非一度ご相談下さい。',
  },
  {
    questionText: 'コンポーネントライブラリはどのような形式で納品されますか？',
    answerText:
      '弊社が実装の場合、JSフレームワークはReactとなります。また、デザインファイルはFigmaを基本としていますが、ご指定があればAdobe XDやSketchでの納品も可能です。',
  },
  {
    questionText: '社内にデザイナーがほとんどいないのですが大丈夫ですか？',
    answerText:
      'デザインシステムの運用にはデザイナーが必要とされています。とはいえプロダクトの更新頻度や運用体制は企業によって様々ですので、人数が少ない場合であっても管理ができる規模などのご提案を致します。',
  },
  {
    questionText: 'ネイティブアプリのデザインシステムは作成可能ですか？',
    answerText:
      'ネイティブアプリにはHuman Interface GuidelineやMaterial Designといったプラットフォーマーのデザインシステムが存在しています。これに加えて独自のデザインシステムを構築するのは複雑になりコンフリクトが発生してしまいますので、基本的にはプラットフォーム毎のデザインシステムを準拠するか、範囲を限定して作成することをおすすめしています。',
  },
]

const QA = () => {
  const section = useRef<HTMLElement>()
  const slide = useRef<HTMLDivElement>()
  useEffect(() => {
    gsap.to(slide.current, {
      width: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: section.current,
        start: 'top-=350 top+=200',
      },
    })
  }, [])

  const FAQList = FAQLists.map(({ questionText, answerText }, index) => (
    <li key={index}>
      <div className={styles.q_row}>
        <div className={styles.q}>Q</div>
        <p>{questionText}</p>
      </div>
      <div className={styles.a_row}>
        <div className={styles.a}>A</div>
        <p>{answerText}</p>
      </div>
    </li>
  ))

  return (
    <section className={styles.qa} ref={section}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div className={styles.slider} ref={slide}></div>
          <span>FAQ</span>
          <h2>よくある質問</h2>
        </div>
        <div className={styles.lists}>
          <ul>{FAQList}</ul>
        </div>
      </div>
    </section>
  )
}

export default QA
